var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default btn-xs",on:{"click":function($event){return _vm.$emit('toggleHelp')}}},[_vm._v("\n  Help "),(!_vm.helpAreaVisible)?_c('span',[_vm._v("▾")]):_c('span',[_vm._v("▴")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-11737930","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/guided-analyses/help/toggle-help-button.vue
// module id = YAoe
// module chunks = 0